import React from "react";

const Arrays_and_Loops = () => {
  return (
    <div>
      <h1>Arrays_and_Loops Component</h1>
      <p>Content for Arrays_and_Loops goes here...</p>
    </div>
  );
};

export default Arrays_and_Loops;
